import { lockBodyScroll } from '@/scripts/tools/utilities';

document.addEventListener('alpine:init', () => {
  Alpine.data('header', () => ({
    mobileMenuOpen: false,

    init() {
      this.lockBodyScroll();
    },

    lockBodyScroll() {
      lockBodyScroll(this.mobileMenuOpen);
    },
  }));
});
